export default class ModalExtractor {
    constructor() {
        const modals = document.querySelectorAll('.modal')
        modals.forEach((modal) => this.extractModal(modal))
    }

    extractModal(modal) {
        document.body.appendChild(modal)
    }
}
